import { render, staticRenderFns } from "./recordReport.vue?vue&type=template&id=19699860&"
import script from "./recordReport.vue?vue&type=script&lang=js&"
export * from "./recordReport.vue?vue&type=script&lang=js&"
import style0 from "./recordReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports